<template>
    <div class="scc-quote" :style="`background-image:url(${backgroundImage})`">
        <span class="scc-quote__text h4">&ldquo;{{ title }}&rdquo;</span>
    </div>
</template>

<script>
import './scc-quote.scss';

export default {
    name: 'SccQuote',
    __editor: {
        fields: {
            backgroundImage: {
                widget: 'media',
            },
        },
    },
    props: {
        title: {
            type: String,
            default: 'Be yourself; everyone else is already taken.',
        },
        backgroundImage: {
            type: String,
            default: 'http://www.placehold.it/400x400',
        },
    },
};
</script>
